import { useDispatch } from 'react-redux';
import { TStoreFromCreateStore } from 'store/create-store';

type TAppDispatch = TStoreFromCreateStore['dispatch'];

export const useAppDispatch = () => useDispatch<TAppDispatch>();